import { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import { api } from "@/lib/api";

const CONSENT_KEY = "abnormal_cookie_consent";
const readConsent = () => { try { return localStorage.getItem(CONSENT_KEY); } catch { return null; } };

/**
 * Tracks page views privately (no cookies, no personal data).
 * Fires /api/track ONLY after the visitor accepted analytics ("all").
 */
export default function useAnalytics() {
    const location = useLocation();
    const last = useRef(null);
    const [consent, setConsent] = useState(readConsent);

    useEffect(() => {
        const onConsent = (e) => setConsent(e.detail ?? readConsent());
        window.addEventListener("abnormal-consent", onConsent);
        return () => window.removeEventListener("abnormal-consent", onConsent);
    }, []);

    useEffect(() => {
        if (consent !== "all") return;
        const path = location.pathname + (location.search || "");
        if (path === last.current) return;
        last.current = path;
        api.post("/track", { path, ev: "pageview", ref: document.referrer || null }).catch(() => {});
    }, [location.pathname, location.search, consent]);
}
